import Http from '@/libs/http.js';

/**
 * 获取日志列表
 * @returns {Promise}
 */
export const getLogInfo = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/getLogInfo',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 查日志详情
 * @returns {Promise}
 */
export const getContentInfo = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/getContentInfo',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 上传网盘
 * @returns {Promise}
 */
export const uploadnetpan = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.postfile('/uploadnetpan',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 保存日志
 * @returns {Promise}
 */
export const saveLogContent = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/saveLogContent',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};
/**
 * 查询日志模板
 * @returns {Promise}
 */
export const getModelInfo = (data) => {
    return new Promise((resolve, reject) => {
        const instance=new Http()
        instance.post('/getModelInfo',data)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err);
        });
    });
};